import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Field, reduxForm } from 'redux-form';

import Button from 'shared/components/Button';
import renderInputField from 'shared/forms/RenderInputField';
import { required } from 'shared/forms/validators';
import CityField from 'shared/forms/CityField';

import { requestUpdateBillingInfo } from 'shared/components/ChangePlanModal/ducks';
import { extractBillingData } from 'shared/components/ChangePlanModal/utils';

import { prepareBillingInfoData } from './utils';

import styles from './styles.module.scss';

const FORM_NAME = 'changePlanProfileForm';

class ProfileForm extends React.Component {
  submit = data => {
    const billingInfoData = prepareBillingInfoData({
      data
    });

    this.props.requestUpdateBillingInfo(billingInfoData, FORM_NAME);
  };

  render() {
    const { handleSubmit, submitting, invalid } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.titleBar}>
            <div className={styles.pageTitle}>Just a little about you</div>
            <div className={styles.secondaryTitle}>
              So we can send you an invoice for your records.
            </div>
          </div>
          <div className={styles.formWrapper}>
            <form className={styles.form} onSubmit={handleSubmit(this.submit)}>
              <div className="form-group">
                <label className={classnames(styles.formLabel, 'form-label')}>
                  Full Name*
                </label>
                <Field
                  name="billing_full_name"
                  component={renderInputField}
                  placeholder="Enter full name"
                  validate={required}
                />

                <label className={classnames(styles.formLabel, 'form-label')}>
                  Company Name (optional)
                </label>
                <Field
                  name="billing_company_name"
                  component={renderInputField}
                  placeholder="Enter company name"
                />

                <label className={classnames(styles.formLabel, 'form-label')}>
                  Address Line 1*
                </label>
                <Field
                  name="billing_address_line"
                  component={renderInputField}
                  placeholder="Enter address line 1"
                  validate={required}
                />

                <label className={classnames(styles.formLabel, 'form-label')}>
                  Town/City*
                </label>
                <CityField
                  name="billing_city"
                  placeholder="Enter town/city"
                  validate={required}
                />

                <label className={classnames(styles.formLabel, 'form-label')}>
                  Postcode*
                </label>
                <Field
                  name="billing_postcode"
                  component={renderInputField}
                  placeholder="Enter postcode"
                  validate={required}
                />
              </div>
              <Button
                color="primary"
                type="submit"
                className={styles.submitBtn}
                disabled={submitting || invalid}>
                Continue
              </Button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

ProfileForm = reduxForm({
  form: FORM_NAME
})(ProfileForm);

const mapStateToProps = state => {
  const { user } = state.me;

  const initialBillingCity = _.get(user, 'profile.billing_city.id')
    ? {
        value: _.get(user, 'profile.billing_city.id'),
        label: _.get(user, 'profile.billing_city.name')
      }
    : null;

  return {
    initialValues: {
      ...extractBillingData(user.profile),
      billing_city: initialBillingCity
    },
    enableReinitialize: true
  };
};
const mapDispatchToProps = { requestUpdateBillingInfo };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileForm);
